const liveRouter = [
  {
    path: '/live',
    name: 'liveList',
    component: () => import('../views/live/list'),
		meta: {
			isLogin: false
		}
  },
  {
    path: '/live/:token',
    name: 'liveDetail',
    component: () => import('../views/live/detail'),
		meta: {
			isLogin: false
		}
  }
]

export default liveRouter
